import { Component, Inject, OnInit, Optional } from '@angular/core';
import { DriverService } from '../../services/driver.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';

@Component( {
  selector: 'app-minus-summ-driver-dialog',
  templateUrl: './minus-summ-driver-dialog.component.html',
  styleUrls: ['./minus-summ-driver-dialog.component.scss']
} )
export class MinusSummDriverDialogComponent implements OnInit {

  id: string;
  service: number;
  in_proccess = false;
  reppForm;

  constructor ( private driverService: DriverService,
                public dialogRef: MatDialogRef<MinusSummDriverDialogComponent>,
                @Optional() @Inject( MAT_DIALOG_DATA ) private data: any,
                private fb: FormBuilder,
                private snackBar: MatSnackBar ) {
    this.service = data.service;
    this.id = data.id;
  }

  ngOnInit () {
    this.reppForm = this.fb.group( {
      'MinusSumm': ['', [Validators.required, Validators.max( 1000 )]]
    } );
  }

  driverMinusSumm () {
    this.in_proccess = true;
    this.driverService.driverMinus( this.id, this.reppForm.value.MinusSumm, this.service ).pipe(
    ).subscribe( {
      next: data => {
        this.in_proccess = false;
        this.dialogRef.close( data );
      },
      error: err => {
        this.in_proccess = false;
      }
    } );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/minus-summ-driver-dialog/minus-summ-driver-dialog.component.ts